import { render } from "./ListFilterGeneric.vue?vue&type=template&id=2bde880a"
import script from "./ListFilterGeneric.vue?vue&type=script&lang=js"
export * from "./ListFilterGeneric.vue?vue&type=script&lang=js"
script.render = render

export default script